import { BaseType } from '../../base/base-type';

export class AnnuityType extends BaseType {
  public deathBenefits!: string | null;
}
